// ─── Who a website profile is: trainer, mentor or both ───────────────────
//
// Mirrors vc_be/utils/cmsTeamProfile.js (TEAM_KINDS, normaliseKind) and
// vc_cms/lib/team.js (TEAM_KIND_LABEL, kindOf). The three are one rule kept
// in three codebases, so a kind added here must be added in both of those.
//
// ⚠️ An absent kind is a TRAINER: every profile saved before the field
// existed sat in a section titled "Trainers", and nothing was backfilled.

export const TEAM_KINDS = ['trainer', 'mentor', 'both'];

export const TEAM_KIND_LABEL = {
  trainer: 'Trainer',
  mentor: 'Mentor',
  both: 'Trainer & mentor',
};

/** @returns {'trainer'|'mentor'|'both'} */
export const teamKindOf = (member) => (TEAM_KINDS.includes(member?.kind) ? member.kind : 'trainer');

export const isTrainer = (member) => teamKindOf(member) !== 'mentor';
export const isMentor = (member) => teamKindOf(member) !== 'trainer';
